var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStarFavorito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0.5)",
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.5L9.08749 8.415L1.45999 9.5175L6.97999 14.9025L5.67499 22.5L12.5 18.915L19.325 22.5L18.02 14.9025L23.54 9.525L15.9125 8.415L12.5 1.5Z",
    fill: "#F3C74B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarFavorito);
export default __webpack_public_path__ + "static/media/icon-star-favorito.6865546ac03c0d34ab7f0b5b0feb6411.svg";
export { ForwardRef as ReactComponent };